import React, { useMemo } from 'react';
import {
  Navigate,
  NavigateOptions,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

export function useAppNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  // URLSearchParams to recover query parameters from the URL (location.search)
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  // Navigation method
  const appNavigate = (path: string, params?: NavigateOptions) => {
    navigate(path, params);
  };

  // Link component
  const appLink = (to: string, replace = false) => (
    <Navigate to={to} replace={replace} />
  );

  return {
    appNavigate,
    pathname: location.pathname,
    appLink,
    searchParams: useParams,
    queryParams,
  };
}
